import { makeStyles } from "@fluentui/react-components";

export const useRenderRankingBoosterStyles = makeStyles({
  wrapperContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "stretch",
    flexDirection: "row",
    columnGap: "10px",
    flexWrap: "nowrap",
    boxSizing: "border-box",
    "@media screen and (max-width: 500px)": {
      flexDirection: "column",
    },
  },
  wrapper: {
    display: "flex",
    alignItems: "center",
    flexGrow: 1,
    justifySelf: "flex-end",
    boxSizing: "border-box",
  },
  checkbox: {
    flex: "1 0 55%",
    "&:hover": {
      "--fui-Checkbox__indicator--backgroundColor": "#6A467C",
    },
    "&:active": {
      "--fui-Checkbox__indicator--backgroundColor": "#6A467C",
    },
  },
  checkboxChecked: {
    "--fui-Checkbox__indicator--backgroundColor": "#6A467C",
  },
  slider: {
    "--fui-Slider__thumb--color": "#6A467C",
    "--fui-Slider__progress--color": "#6A467C",
    "&:hover": {
      "--fui-Slider__thumb--color": "#6A467C",
      "--fui-Slider__progress--color": "#6A467C",
    },
    "&:active": {
      "--fui-Slider__thumb--color": "#6A467C",
      "--fui-Slider__progress--color": "#6A467C",
    },
    width: "100%",
  },
});
